import { gql } from '@apollo/client';

export const RandomNumberQueryName = 'RandomNumberQuery';

export const RANDOM_NUMBER_QUERY = gql`
  query ${RandomNumberQueryName} {
    getMyScore
  }
`;
